import { AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { KYMW00Model } from "src/app/commons/kymw00/kymw00.model";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { PlessViewHelperSub } from "src/app/commons/kymw00/pless-view-helper-sub";
import { PlessAlert } from "src/app/shared/pless-alert/pless-alert.component";
import { KYMW6901MasterInputTabComponent } from "./kymw6901-master-input-tab/kymw6901-master-input-tab.component";
import { MasterInputModel } from "./kymw6901-master-input-tab/vo/master-input.model";
import { KYMW6901ProposalTabComponent } from "./kymw6901-proposal-tab/kymw6901-proposal-tab.component";
import { KYMW6901Model } from "./kymw6901.model";
import { PlessViewUtilsSub } from 'src/app/commons/kymw00/pless-view-utils-sub.service';

@Component({
  selector: 'app-kymw6901',
  templateUrl: 'kymw6901.component.html',
  styleUrls: ['kymw6901.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW6901Component extends PlessViewHelperSub implements OnInit, AfterViewInit {
  @ViewChild(KYMW6901ProposalTabComponent) ProposalTab: KYMW6901ProposalTabComponent;
  @ViewChild(KYMW6901MasterInputTabComponent) MasterInputTab: KYMW6901MasterInputTabComponent;


  model = new KYMW6901Model();
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    protected kymw00Model: KYMW00Model,
    private dialogServiceSub: PlessDialogServiceSub
  ) {
    super(kymw00Model);
  }

  ngOnInit() {
    this.componentName = 'KYMW6901';

    this.route.queryParams.subscribe((queryParams) => {
      if ('proposalId' in queryParams) {
        this.model.proposalId = queryParams['proposalId'];
      }
      if ('proposalStatus' in queryParams) {
        this.model.proposalStatus = queryParams['proposalStatus'];
      }
      if ('masterInputId' in queryParams) {
        this.model.masterInputId = queryParams['masterInputId'];
      }
      if ('defaultTab' in queryParams) {
        this.model.defaultTab = queryParams['defaultTab'];
      }
      if ('mode' in queryParams) {
        this.model.mode = queryParams['mode'];
      }
      if ('pcode' in queryParams) {
        this.model.pCode = queryParams['pcode'];
      }
      if ('itemCode' in queryParams) {
        this.model.itemCode = queryParams['itemCode'];
      }
      if ('classCode' in queryParams) {
        this.model.classCode = queryParams['classCode'];
      }
      // 検索条件
      if ('searchProposalStatus' in queryParams) {
        this.model.searchProposalStatus = queryParams['searchProposalStatus'];
      }
      if ('searchClassCode' in queryParams) {
        this.model.searchClassCode = queryParams['searchClassCode'];
      }
      if ('searchProposalUserId' in queryParams) {
        this.model.searchProposalUserId = queryParams['searchProposalUserId'];
      }
      if ('searchBuyerId' in queryParams) {
        this.model.searchBuyerId = queryParams['searchBuyerId'];
      }
      if ('searchGoodsAndStandardName' in queryParams) {
        this.model.searchGoodsAndStandardName = queryParams['searchGoodsAndStandardName'];
      }
      if ('searchStartOrderCode' in queryParams) {
        this.model.searchStartOrderCode = queryParams['searchStartOrderCode'];
      }
      if ('searchDelivCatalogId' in queryParams) {
        this.model.searchDelivCatalogId = queryParams['searchDelivCatalogId'];
      }
      if ('searchPCode' in queryParams) {
        this.model.searchPCode = queryParams['searchPCode'];
      }
      if ('searchMasterInputStatus' in queryParams) {
        this.model.searchMasterInputStatus = queryParams['searchMasterInputStatus'];
      }
    });

    if (this.model.defaultTab === KYMW6901Model.TAB_MASTER_INPUT) {
      this.model.showMasterInputTab();
    }
  }

  ngAfterViewInit() {
    this.ProposalTab.model.parent = this;
    this.MasterInputTab.model.parent = this;
  }

  eventBack_CLICKHandler() {
    if (this.ProposalTab.hasChanged() || this.MasterInputTab.hasChanged()) {
      this.dialogServiceSub.openAlertGetMessage('Q0183', [],
        (closeDetail: PlessAlert) => {
          if (closeDetail === PlessAlert.Yes) {
            this.router.navigate(['/kymw/6900'], {
              queryParams: {
                searchProposalStatus: this.model.searchProposalStatus,
                searchClassCode: this.model.searchClassCode,
                searchProposalUserId: this.model.searchProposalUserId,
                searchBuyerId: this.model.searchBuyerId,
                searchGoodsAndStandardName: this.model.searchGoodsAndStandardName,
                searchStartOrderCode: this.model.searchStartOrderCode,
                searchPCode: this.model.searchPCode,
                searchMasterInputStatus: this.model.searchMasterInputStatus
              }
            });
          }
        }
      );
    } else {
      this.router.navigate(['/kymw/6900'], {
        queryParams: {
          searchProposalStatus: this.model.searchProposalStatus,
          searchClassCode: this.model.searchClassCode,
          searchProposalUserId: this.model.searchProposalUserId,
          searchBuyerId: this.model.searchBuyerId,
          searchGoodsAndStandardName: this.model.searchGoodsAndStandardName,
          searchStartOrderCode: this.model.searchStartOrderCode,
          searchDelivCatalogId: this.model.searchDelivCatalogId,
          searchPCode: this.model.searchPCode,
          searchMasterInputStatus: this.model.searchMasterInputStatus
        }
      });
    }
  }

  sendMasterInput(newMasterInput: MasterInputModel) {
    this.MasterInputTab.model.masterInput = newMasterInput;
    this.MasterInputTab.setInit_AfterCopy();
  }


  updateMasterInput(onSuccess: () => void) {
    this.MasterInputTab.updateMasterInputOnProposal(onSuccess);
  }

  registerMasterInput(proposalId: string, classCode: string, onSuccess: () => void) {
    this.MasterInputTab.registerMasterInputOnProposal(proposalId, classCode, onSuccess);
  }
}